module.exports = __webpack_public_path__ + "img/chinesecompany220.ac1b300a.png";